/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createDiffusionList } from '../fn/diffusion-list/create-diffusion-list';
import { CreateDiffusionList$Params } from '../fn/diffusion-list/create-diffusion-list';
import { deleteDiffusionList } from '../fn/diffusion-list/delete-diffusion-list';
import { DeleteDiffusionList$Params } from '../fn/diffusion-list/delete-diffusion-list';
import { DiffusionListPaged } from '../models/diffusion-list-paged';
import { retrieveDiffusionList } from '../fn/diffusion-list/retrieve-diffusion-list';
import { RetrieveDiffusionList$Params } from '../fn/diffusion-list/retrieve-diffusion-list';
import { searchDiffusionLists$Any } from '../fn/diffusion-list/search-diffusion-lists-any';
import { SearchDiffusionLists$Any$Params } from '../fn/diffusion-list/search-diffusion-lists-any';
import { searchDiffusionLists$Json } from '../fn/diffusion-list/search-diffusion-lists-json';
import { SearchDiffusionLists$Json$Params } from '../fn/diffusion-list/search-diffusion-lists-json';
import { SingleDiffusionList } from '../models/single-diffusion-list';
import { updateDiffusionList } from '../fn/diffusion-list/update-diffusion-list';
import { UpdateDiffusionList$Params } from '../fn/diffusion-list/update-diffusion-list';


/**
 * All about the diffusion lists
 */
@Injectable({ providedIn: 'root' })
export class DiffusionListService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchDiffusionLists()` */
  static readonly SearchDiffusionListsPath = '/users/diffusionlist/search';

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDiffusionLists$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDiffusionLists$Json$Response(params?: SearchDiffusionLists$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DiffusionListPaged>> {
    return searchDiffusionLists$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDiffusionLists$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDiffusionLists$Json(params?: SearchDiffusionLists$Json$Params, context?: HttpContext): Observable<DiffusionListPaged> {
    return this.searchDiffusionLists$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DiffusionListPaged>): DiffusionListPaged => r.body)
    );
  }

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDiffusionLists$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchDiffusionLists$Any$Response(params?: SearchDiffusionLists$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<DiffusionListPaged>> {
    return searchDiffusionLists$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDiffusionLists$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchDiffusionLists$Any(params?: SearchDiffusionLists$Any$Params, context?: HttpContext): Observable<DiffusionListPaged> {
    return this.searchDiffusionLists$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<DiffusionListPaged>): DiffusionListPaged => r.body)
    );
  }

  /** Path part for operation `createDiffusionList()` */
  static readonly CreateDiffusionListPath = '/users/diffusionlist';

  /**
   * Create a diffusion list.
   *
   * Create a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDiffusionList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiffusionList$Response(params: CreateDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a diffusion list.
   *
   * Create a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDiffusionList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiffusionList(params: CreateDiffusionList$Params, context?: HttpContext): Observable<void> {
    return this.createDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `retrieveDiffusionList()` */
  static readonly RetrieveDiffusionListPath = '/users/diffusionlist/{uid}';

  /**
   * retrieve a diffusion list.
   *
   * retrieve a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveDiffusionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveDiffusionList$Response(params: RetrieveDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleDiffusionList>> {
    return retrieveDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve a diffusion list.
   *
   * retrieve a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveDiffusionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveDiffusionList(params: RetrieveDiffusionList$Params, context?: HttpContext): Observable<SingleDiffusionList> {
    return this.retrieveDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<SingleDiffusionList>): SingleDiffusionList => r.body)
    );
  }

  /** Path part for operation `updateDiffusionList()` */
  static readonly UpdateDiffusionListPath = '/users/diffusionlist/{uid}';

  /**
   * Update a diffusion list.
   *
   * Update a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDiffusionList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiffusionList$Response(params: UpdateDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a diffusion list.
   *
   * Update a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDiffusionList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiffusionList(params: UpdateDiffusionList$Params, context?: HttpContext): Observable<void> {
    return this.updateDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteDiffusionList()` */
  static readonly DeleteDiffusionListPath = '/users/diffusionlist/{uid}';

  /**
   * Delete a diffusion list.
   *
   * Delete a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDiffusionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDiffusionList$Response(params: DeleteDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a diffusion list.
   *
   * Delete a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDiffusionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDiffusionList(params: DeleteDiffusionList$Params, context?: HttpContext): Observable<void> {
    return this.deleteDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
